export default __webpack_public_path__ + "static/media/background.47cc6935.svg";